import * as React from 'react';
import {SCREENS, WP_CONTENT_PREFIX} from '../../constants';
import {Background} from '../../styled-components/Background';
import {PlotArea, PlotAreaMargin, PlotAreaWrapper} from '../../styled-components/PlotAreaComps';
import {StatusBar} from '../StatusBar';
import {Cloud} from '../../styled-components/Cloud';
import {FlexColumm} from '../../styled-components/FlexColumn';
import styled from 'styled-components';
import VisibilitySensor from 'react-visibility-sensor';
import {analyticsEvent, sendGAEventToExtension} from '../../utils/analytics';
import {GestureGif, GroundInfo, InfoTitle} from "../GroundInfo";
import {Title} from "../../styled-components/Title";
import I18n from '../../utils/i18n';
import ReactHtmlParser from 'react-html-parser';
import {HelpOverlay} from "../HelpOverlay";
import BouncePrevention from "../../utils/BouncePrevention";
import {BounceOverlay} from "../BounceOverlay";

const TrashOpen = styled.img`
    height: 12vh;
    width: 10vw;
    margin-top: 11vh;
`;

const TrashClose = styled.img`
    height: 15vh;
    margin-top: 20vh;
`;

const Fish = styled.img`
    height: 2vh;
    margin-top: 33vh;
`;

const CatAndMouse = styled.img`
    height: 30vh;
    width: 17vw;
`;

const Fence = styled.img`
    width: 30vw;
    margin-top: 4vh;
`;

export class FourthScreen extends React.Component {

    constructor() {
        super();
        this.OVERLAY_TYPES = {
            help: 'help',
            bounce: 'bounce'
        };
        this.state = {
            showHelpOverlay: false,
            showBounceOverlay: false,
            currentOverlay: null
        };
        this.onVisible = this.onVisible.bind(this);
        this.closeHelpOverlay = this.closeHelpOverlay.bind(this);
        this.closeBounceOverlay = this.closeBounceOverlay.bind(this);
        this.renderOverlays = this.renderOverlays.bind(this);
    }

     onVisible(isVisible) {
        if(isVisible) {
            analyticsEvent('Onboarding',
                'Screen 4',
                'Shown'
            );
            const currentScreen = 4;
            history.pushState({screen: currentScreen}, "", `?screen=${currentScreen}`);
            sendGAEventToExtension('Onboarding', 'Screen 4', 'Shown');
            BouncePrevention.startObserving(() => {
                this.setState({
                    showHelpOverlay: true
                });
            });
            BouncePrevention.startBouncePrevention(() => {
                this.setState({
                    showBounceOverlay: true
                })
            });
        }
    }

    closeHelpOverlay() {
        this.setState({
            showHelpOverlay: false
        });
    }

    closeBounceOverlay() {
        this.setState({
            showBounceOverlay: false
        });
    }

    renderOverlays() {
        const {currentOverlay} = this.state;

        if (currentOverlay === this.OVERLAY_TYPES.help) {
            return <HelpOverlay closeHelpOverlay={this.closeHelpOverlay} screen={SCREENS.fourth} />
        } else if (currentOverlay === this.OVERLAY_TYPES.bounce) {
            return <BounceOverlay screen={SCREENS.fourth} closeBounceOverlay={this.closeBounceOverlay} />
        } else {
            return null;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        const {showHelpOverlay, showBounceOverlay} = this.state;

        // hide help overlay
        if (showHelpOverlay && !nextState.showHelpOverlay) {
            this.setState({
                showBounceOverlay: false,
                currentOverlay: null
            });
            // show help overlay
        } else if (!showHelpOverlay && nextState.showHelpOverlay) {
            this.setState({
                currentOverlay: showBounceOverlay ? this.OVERLAY_TYPES.bounce : this.OVERLAY_TYPES.help
            });
        }
        // hide bounce overlay
        if (showBounceOverlay && !nextState.showBounceOverlay) {
            this.setState({
                showHelpOverlay: false,
                currentOverlay: null
            });
            // show bounce overlay
        } else if (!showBounceOverlay && nextState.showBounceOverlay) {
            this.setState({
                currentOverlay: showHelpOverlay ? this.OVERLAY_TYPES.help : this.OVERLAY_TYPES.bounce
            });
        }
        return true;
    }

    render() {
        const {toggleMusicPlaying, musicPlaying} = this.props;

        return (
            <Background>
                {this.renderOverlays()}
                <PlotAreaWrapper>
                    <StatusBar screen={SCREENS.fourth} toggleMusicPlaying={toggleMusicPlaying} musicPlaying={musicPlaying}/>
                    <Title>{I18n.translate('gestureInstructions4')}</Title>
                    <PlotArea>
                        <PlotAreaMargin margin='10vw' />
                        <FlexColumm>
                            <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='7vh' />
                            <TrashOpen src={`${WP_CONTENT_PREFIX}/images/cat_screen_trash02.png`} />
                        </FlexColumm>
                        <PlotAreaMargin margin='1vw' />
                        <TrashClose src={`${WP_CONTENT_PREFIX}/images/cat_screen_trash01.png`} />
                        <PlotAreaMargin margin='1vw' />
                        <Fish src={`${WP_CONTENT_PREFIX}/images/fish.png`} />
                        <PlotAreaMargin margin='10vw' />
                        <FlexColumm>
                            <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginLeft='10vw' />
                            <CatAndMouse src={`${WP_CONTENT_PREFIX}/images/mouse_vs_cat.gif`} />
                        </FlexColumm>
                        <PlotAreaMargin margin='5vw' />
                        <FlexColumm>
                            <Cloud src={`${WP_CONTENT_PREFIX}/images/cloud.png`} marginTop='10vh' />
                            <Fence src={`${WP_CONTENT_PREFIX}/images/fence.png`} />
                        </FlexColumm>
                    </PlotArea>
                </PlotAreaWrapper>
                    <GroundInfo extensionInstalled={true} screen={SCREENS.fourth}>
                        <React.Fragment>
                            <VisibilitySensor onChange={this.onVisible}>
                                <InfoTitle marginTop="4vh" fontSize="2vh"> *** {I18n.translate('gameReference4')} ***</InfoTitle>
                            </VisibilitySensor>
                            <InfoTitle marginTop="3vh">{ReactHtmlParser(I18n.translate('movementInstructions4'))}</InfoTitle>
                            <GestureGif src={`${WP_CONTENT_PREFIX}/images/right_up.gif`}></GestureGif>
                        </React.Fragment>
                    </GroundInfo>
            </Background>
        );
    }
}
